import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

export type V_UserSub = {
  '@id': string;
  '@type': 'MetricSymptom';
};

export function useReadCollectionMetricSymptomsStartDateEndDate(
  id: string,
  startDate: string,
  endDate: string,
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_UserSub>>(
    `/users/${id}/metric-symptoms/${startDate}/${endDate}`,
    options,
  );
}
